/**
 * Opens a page of the application in a new browser tab.
 * @param url url of the page inside the application
 */
export const openPageInNewTab = (url: string) => {
  window.open(url, '_blank', 'noopener');
};

/**
 * Props that make a link open its page in a new browser tab.
 *
 * Spread it conditionally: `{...(openInNewTab && NEW_TAB_LINK_PROPS)}`.
 */
export const NEW_TAB_LINK_PROPS = { target: '_blank', rel: 'noopener noreferrer' };
